import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import Metrics from '@spotahome/soyuz-metrics';

import { ROOM_TYPES } from '@common/constants';

import Checkbox from '../../../LEGACY/javascripts/ui/form/form-checkbox';

class AlertPropertyTypes extends PureComponent {
  static propTypes = {
    propertyTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
    onChange: PropTypes.func.isRequired
  };

  setPropertyType = newType => checked => {
    let { propertyTypes } = this.props;
    if (checked) {
      propertyTypes = [...propertyTypes, newType];
      Metrics.ga.sendEvent(
        'My alerts',
        'set alerts property type',
        `click ${newType} property button`
      );
    } else {
      propertyTypes = propertyTypes.filter(type => type !== newType);
    }
    this.props.onChange(propertyTypes);
  };

  render() {
    return (
      <Fragment>
        <div className="add-edit-form__grid-label add-edit-form__grid-label--top">
          {trans('alerts.modal.property_type')}
        </div>
        <div>
          {ROOM_TYPES.map(type => (
            <Checkbox
              id={`alert_${type}`}
              label={trans(`search.filter.${type}`)}
              checked={this.props.propertyTypes.includes(type)}
              onChange={this.setPropertyType(type)}
            />
          ))}
        </div>
      </Fragment>
    );
  }
}

export default AlertPropertyTypes;
